import JeddahCourniche from "./jeddahCourniche.mdx"
import JeddahCourniche_ar from "./jeddahCourniche_ar.mdx"
import { useLang } from "hooks/useLang"
import FadeOutEffect from "components/atoms/FadeOutEffect"
const JeddahCournicheComponent = () => {
    const { lang } = useLang()
    const renderJeddahCourniche =
        lang === "ar" ? <JeddahCourniche_ar /> : <JeddahCourniche />
    return (
        <FadeOutEffect fadeStartAt={200} fadeHeight={50}>
            <div className="max-w-2xl">
                <div
                    style={{
                        fontWeight: 300,
                    }}
                >
                    {renderJeddahCourniche}
                </div>
            </div>
        </FadeOutEffect>
    )
}

export default JeddahCournicheComponent
